import { Box, Typography } from "@mui/material";
import ProjectBox from "../../components/ProjectBox";
// import Inventory from "../../assets/inventoryManagement.png";
import Storefront from "../../assets/ecommerce/storefront.png";
import NYUSHRMP from "../../assets/NYUSHRMP.png";
// import BusinessDashboard from "../../assets/tdcdashboard.png";
import orderManagement from "../../assets/businessdashboard/orderManagement.png";
import AIFlashcards from "../../assets/AIFlashcards.png";
// import ClickAwayListener from "@mui/material/ClickAwayListener";
import CustomerSupport from "../../assets/ecommerce/cxsupport.png";
import { motion } from "motion/react";
import { useState } from "react";

const containerVariants = {
  hidden: { opactiy: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.2,
    },
  },
};
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const Projects = () => {
  const [selected, setSelected] = useState("");

  return (
    <Box width={"100%"}>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
      >
        <Typography variant="h2">Projects</Typography>
        {/* <Typography variant="h2">Featured </Typography>
            <Grid2 container spacing={2}>
              {/* <Grid2 xs={12}>
                <ProjectBox
                  title="Business Dashboard"
                  link="/smallbizdashboard"
                  location="TDC Doors"
                  date="Jan 2025 - Present"
                  description="A operations management dashboard for the small business owner. Utilizes distributed systems and multiple user views."
                  img={TDC}
                  tags={["Operations", "Supply Chain"]}
                />
              </Grid2> */}
        {/* <Grid2 xs={12}>
                <ProjectBox
                  title="E-Commerce Storefront"
                  link="/storefront"
                  location="TDC Doors"
                  date="Jan 2025 - Present"
                  img={OnlineStore}
                  description="Enables small business owners to launch and manage their online stores with no coding experience needed."
                  tags={["Marketing", "Sales", "Distribution"]}
                />
              </Grid2> */}
        {/* <Grid2 xs={12}>
                <ProjectBox
                  title="Books"
                  link="/"
                  location="TDC Doors"
                  date="Coming Soon"
                  description="Enables small business to manage books, finances, taxes, payroll."
                  tags={["Finance", "Bookkeeping"]}
                />
              </Grid2> */}
        {/* </Grid2> */}

        <motion.h2 variants={itemVariants}>
          <ProjectBox
            title="Storefront"
            link="/storefront"
            location=""
            date="May 2026"
            selected={selected}
            setSelected={setSelected}
            description="An ecommerce store"
            img={Storefront}
          />

          <ProjectBox
            title="Business Dashboard"
            link="/businessdashboard"
            selected={selected}
            setSelected={setSelected}
            date="May 2026"
            description="An internal tool used to manage customer orders"
            img={orderManagement}
          />

          <ProjectBox
            title="Customer Support Chatbot"
            link="/cxchatbot"
            selected={selected}
            setSelected={setSelected}
            date="Mar 2026"
            description="A customer support chat assistant"
            img={CustomerSupport}
          />
          {/* <ProjectBox
            title="Inventory Management"
            link="/inventorymanagement"
            selected={selected}
            setSelected={setSelected}
            date="Oct 2025"
            description="A inventory management tool for your business"
            img={Inventory}
          /> */}
          <ProjectBox
            title="AI Flashcards"
            link="/aiflashcards"
            selected={selected}
            setSelected={setSelected}
            location="Headstarter AI"
            date="Aug 2024"
            description="A study tool that generates flashcards on any topic."
            img={AIFlashcards}
          />
          {/* missing demo and improve application */}
          <ProjectBox
            title="Rate My Professor Assistant"
            link="/rmpassistant"
            selected={selected}
            setSelected={setSelected}
            location="Headstarter AI"
            date="Aug 2024"
            description=" A chat assistant to help NYU SH students find professors based on their teaching preferences. "
            img={NYUSHRMP}
          />
        </motion.h2>
      </motion.div>
    </Box>
  );
};

export default Projects;
